import { render, staticRenderFns } from "./sonQuantity.vue?vue&type=template&id=1b46cc62&scoped=true"
import script from "./sonQuantity.vue?vue&type=script&lang=js"
export * from "./sonQuantity.vue?vue&type=script&lang=js"
import style0 from "./sonQuantity.vue?vue&type=style&index=0&id=1b46cc62&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b46cc62",
  null
  
)

export default component.exports